module.exports = __webpack_public_path__ + "static/media/image_placeholder.f8e3be08.jpg";